import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'x-shop-dialog',
  templateUrl: './shop-dialog.component.html',
  styleUrls: ['./shop-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'x-shop-dialog',
  },
})
export class ShopDialogComponent {
  @Input() canClose: boolean | undefined = true;
  @Input() closeTooltip: string | undefined;
  @Input() logo: boolean | undefined;
  @Input() heading: string | undefined;
  @Input() subheading: string | undefined;
  @Input() loading: boolean | undefined | null;
  @Input() headerAlignment: 'start' | 'center' | 'end' = 'center';

  @Output() closeDialog = new EventEmitter<void>();
}
